import { render, staticRenderFns } from "./EcommerceDesignCard.vue?vue&type=template&id=fbb98e62&"
import script from "./EcommerceDesignCard.vue?vue&type=script&lang=js&"
export * from "./EcommerceDesignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports